<template>
  <div class="btn-container">
    <button type="button" @click="loginWithGoogle()" class='btn btn--google'>
      <img src="../../assets/google.svg" alt="Google Logo" />
    </button>
  </div>
</template>

<script>
import { authenticateWithGoogle } from '@/helpers/Auth';

export default {
  name: 'AuthWithGoogle',
  data: function() {
    return {
    };
  },
  methods: {
    loginWithGoogle: async function() {
      await authenticateWithGoogle();
    }
  }
}
</script>

<style lang="sass">
  .section__form {
    .btn--google {
      background-color: $white;
      color: $google-blue;
      height: 46px;
    }
  }
</style>